import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import GameCard from '../components/GameCard';
import Modal from '@material-ui/core/Modal';

import GenrePage from '../components/GenrePage';
import ScorePage from '../components/ScorePage';

const useStyles = makeStyles((theme) => ({
  panel: {
    margin: 50,
    display: "flex",
    justifyContent: "space-evenly"
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: "75vw",
  },
}));

export default function Analytics() {
    const classes = useStyles();
    const [genrePage, setGenrePage] = useState(false);
    const [scorePage, setScorePage] = useState(false);
    const openGenrePage = () => setGenrePage(true);
    const closeGenrePage = () => setGenrePage(false);
    const openScorePage = () => setScorePage(true);
    const closeScorePage = () => setScorePage(false);

    return (
      <Box color="text.primary" className={classes.panel}>
        <GameCard
          img="/imgs/genre.png"
          title="Game Category Prediction"
          description="We predict the game category based on the description of the game offerred by RAWG."
          link="https://rawg.io/"
          reference="RAWG"
          open={openGenrePage}
        />
        <GameCard
          img="/imgs/metacritic.png"
          title="Game Score Prediction"
          description="We predict the game Metacritic score based on the game comments and reviews offerred by Metacritic."
          link="https://www.metacritic.com/"
          reference="Metacritic"
          open={openScorePage}
        />
        <Modal
          open={genrePage}
          onClose={closeGenrePage}
          className={classes.modal}
        >
          <div className={classes.paper}>
            <GenrePage />
          </div>
        </Modal>
        <Modal
          open={scorePage}
          onClose={closeScorePage}
          className={classes.modal}
        >
          <div className={classes.paper}>
            <ScorePage />
          </div>
        </Modal>
      </Box>
    );
}